/**
 * Search Template Options Search Filter
 */
jQuery( document ).ready( function() {
	jQuery( '#post-type-option li span' ).on( 'click', function() {
		jQuery( '#post-type-option li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	jQuery( '#sidebar-type-option li span' ).on( 'click', function() {
		jQuery( '.type-hidden' ).val( jQuery( this ).data( 'post-type' ) );
	} );
	jQuery( '#sidebar-year-option li span' ).on( 'click', function() {
		jQuery( '.year-hidden' ).val( jQuery( this ).data( 'year' ) );
	} );
	jQuery( '#post-year-option li span' ).on( 'click', function() {
		jQuery( '#post-year-option li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	jQuery( '.select-dropdown__list li div' ).on( 'click', function() {
		jQuery( '.select-dropdown__list li div' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );
	jQuery( '#clear-search-field' ).on( 'click', function() {
		 jQuery( '#main_search' ).val( '' );
	} );

	jQuery( document ).on(
		'click', '#post-type-option li, #post-year-option li, #ajax-search-submit, #ajax-pagination, #sort-a-to-z',
		function() {
			jQuery( 'html' ).animate( { scrollTop: 0 }, 'slow' );
			let order = '';
			let postType = '';
			let year = '';
			const search = jQuery( '#main_search' ).val();
			const page = jQuery( this ).data( 'paged' );

			jQuery( '.select-dropdown__list li' ).each( function() {
				const item = jQuery( this ).find( 'div' );
				if ( jQuery( item ).hasClass( 'active' ) ) {
					order = item.data( 'order' );
				}
			} );
			jQuery( '#post-type-option li' ).each( function() {
				const item = jQuery( this ).find( 'span' );
				if ( jQuery( item ).hasClass( 'active' ) ) {
					postType = item.data( 'post-type' );
				}
			} );
			jQuery( '#post-year-option li' ).each( function() {
				const item = jQuery( this ).find( 'span' );
				if ( jQuery( item ).hasClass( 'active' ) ) {
					year = item.data( 'year' );
				}
			} );
			 jQuery( '.init-loader' ).css( 'display', 'block' );
			//  jQuery( '.search-article-container' ).empty();
			jQuery( '.filter-posts' ).addClass( 'ajax-overlay' );
			 jQuery( '.pagination' ).empty();
			jQuery.ajax( {
				url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
				type: 'POST',
				data: {
					action: 'select_filter',
					search,
					postType,
					year,
					page,
					order,

				},
				success( response ) {
					if ( response.html ) {
						jQuery( '.search-article-container' ).html( response.html );
						jQuery( '.init-loader' ).css( 'display', 'none' );
					}
					if ( response.pagination ) {
						jQuery( '.pagination' ).html( response.pagination );

						jQuery( '.init-loader' ).css( 'display', 'none' );
					} else {
						jQuery( '.pagination' ).html( response.pagination );
					}
					jQuery( '.filter-posts' ).removeClass( 'ajax-overlay' );
					jQuery( '#paged' ).html( response.paged );
				    jQuery( '#max-num-pages' ).html( response.totalPages );
				    jQuery( '#total-posts' ).html( response.totalPosts );
				},
			} );
		}
	);
} );
/**
 * Search Template Options Search Filter
 */

